import { logUsage } from 'owa-analytics';
import { PositionType } from 'roosterjs-editor-types';
import LinkPlugin from '../../plugin/LinkPlugin';
import { displaySpinner } from './displaySpinner';

export function displaySpinnerWhenShouldBeautifyLink(
    shouldBeautifyLink: boolean,
    linkPlugin: LinkPlugin,
    linkIdsWithSpinner: string[],
    anchorElement: HTMLAnchorElement
): Node[] | null {
    let addedElements: Node[] | null;
    if (shouldBeautifyLink) {
        // Spinner is only needed when we will beautify the link
        linkPlugin.editor.addUndoSnapshot();
        linkIdsWithSpinner.push(anchorElement.id);
        addedElements = displaySpinner(anchorElement);
        linkPlugin.editor.select(anchorElement, PositionType.After);
        linkPlugin.editor.triggerContentChangedEvent('Link');
        logUsage('AttachmentComposeSPLinksShouldReplaceText');
    }

    return addedElements;
}
